// extracted by mini-css-extract-plugin
module.exports = {"medium":"seatingCard_medium__1279r","container":"seatingCard_container__vQX2o","title":"seatingCard_title__3bHjk"};